<nav
  class="navbar navbar-fixed-top navbar-light navbar-expand-md bg-faded justify-content-center topnav" style="z-index: 1"
>
  <a
    class="navbar-brand d-flex w-50 mr-auto logoName"
    [routerLink]="['home']"
  >
    <span>
      <img
        class="logo"
        src="../../../../assets/theme/img/Header_AccLogo.svg"
        alt="logo"
      />
    </span>
    <span class="heading"> Industry X Developer Hub </span>
  </a>
  <div class="nav navbar-nav navbar-right" id="collapsingNavbar3">
    <ul class="navbar-nav justify-content-center headerRight" id="navMain"></ul>
    <ul class="navbar-nav ml-auto w-20 justify-content-end">
      <li class="nav-item">
        <a
          class="nav-link"
          [routerLink]="['asset-home']"
            [routerLinkActive]="['active']"
            (click)="removeActiveClass();"
          >Assets</a
        >
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          [routerLink]="['contribute']"
            [routerLinkActive]="['active']"
            (click)="removeActiveClass();"
          >Contribute</a
        >
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          [routerLink]="['mybookmarks']"
            [routerLinkActive]="['active']"
            (click)="removeActiveClass();"
          >My Bookmarks</a
        >
      </li>

      <!-- <li class="nav-item helpDropdown">
    <div class="dropdown">
      <a class="dropbtn">Help</a>
      <div class="dropdown-content">
        <a [routerLink]="['faq']">FAQ</a>
        <a [routerLink]="['support']">Support</a>
      </div>
    </div>
  </li> -->
      <li class="nav-item dropdown">
        <a
          class="nav-link"
          id="helpDropdownLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          [ngClass]="{'active': child1RLA.isActive || child2RLA.isActive}"
             >
              Help
            </a>
        <div
          class="dropdown-menu helpDropdown"
        >
          <a
            class="dropdown-item noBorderColor cursorPointer"
            
            [routerLink]="['faq']"
            [routerLinkActive]="['active2']"
            (click)="addActiveClicked()"
            #child1RLA="routerLinkActive">  
            <span class="uil-toolbar-username-item helpTags">FAQ</span>
          </a>
          <hr />
          <a
            class="dropdown-item noBorderColor cursorPointer"
      
            href="mailto:IXDevHub.Support@accenture.com?subject=Industry X Developer Hub : Support Request&body=%0D%0A%0D%0A" target="_blank"
            [routerLinkActive]="['active2']"
            #child2RLA="routerLinkActive"
            >
            <span class="uil-toolbar-username-item helpTags">Support</span>
          </a>
        </div>
      </li>


      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle noBorderColor "
          href="#"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i
            class="uil-dl-icon-User uil-color-secondary sign signIn"
            aria-hidden="true"
          ></i>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item noBorderColor username ">
            Hello, {{ username }}
          </a>
          <hr />
          <a class="dropdown-item noBorderColor cursorPointer" (click)="logout()">
            <span class="uil-dl-icon-Exit signInLogo">
              <span class="uil-toolbar-username-item logOut"> Logout</span>
            </span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</nav>
